import { useQuery } from "@tanstack/react-query";
import ws from "@/utils/service";

export type CMSListResponse = {
  data: {
    data: Array<{
      type: string;
      id: string;
      attributes: {
        type: string;
        body: string;
      };
      links: {
        self: string;
      };
    }>;
  };
};

const useCMSList = (params?: any) => {
  const response = useQuery<CMSListResponse>({
    queryKey: ["CMS", params],
    queryFn: async () => await ws.get(`/api/v1/taxpayers/cms`, { params })
  });
  return { ...response, data: response?.data };
};

export default useCMSList;
